import { render, staticRenderFns } from "./InformationGift.vue?vue&type=template&id=4b10500a&scoped=true&"
import script from "./InformationGift.vue?vue&type=script&lang=js&"
export * from "./InformationGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b10500a",
  null
  
)

export default component.exports